<template>
  <div v-bind:id="divId"></div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<script>
import Plotly from 'plotly.js'

export default {
  name: 'Plot',
  props: {
    data: {
        type: Array,
        required: true
    },
    divId: {
        type: String,
        required: true
    },
    layout: {
        type: Object
    }
  },
  mounted() {
    this.Plot()
    this.$watch('data', this.Plot, { deep: true });
  },
  methods: {
    Plot() {
      return Plotly.newPlot(this.divId, this.data, this.layout, {
        displayModeBar: false
      })
    }
  }
}
</script>
